import { AITool } from '../types'

export const visualPlaceOrderTool: AITool = {
  name: 'visual_place_order',
  description: 'Place a trading order with visual demonstration on the demo component',
  category: 'visual_trading',
  parameters: [
    {
      name: 'symbol',
      type: 'string',
      description: 'Trading pair symbol (e.g., BTCUSDT, ETHUSDT)',
      required: true
    },
    {
      name: 'side',
      type: 'string',
      description: 'Order side: BUY or SELL',
      required: true,
      enum: ['BUY', 'SELL']
    },
    {
      name: 'quantity',
      type: 'number',
      description: 'Amount to trade',
      required: true
    },
    {
      name: 'type',
      type: 'string',
      description: 'Order type: MARKET or LIMIT',
      required: false,
      default: 'MARKET',
      enum: ['MARKET', 'LIMIT']
    },
    {
      name: 'price',
      type: 'number',
      description: 'Price per unit (required for LIMIT orders)',
      required: false
    }
  ],
  examples: [
    'Place a buy order for 0.5 BTCUSDT',
    'Sell 1000 USDT worth of ETH',
    'Place a limit buy order for 2 ETH at $3000'
  ],
  execute: async (params, context) => {
    console.log('🎬 Visual Demo: Executing order with params:', params)
    
    // Try to trigger visual demo through a global event
    const visualEvent = new CustomEvent('visualPlaceOrder', {
      detail: params
    })
    
    // Set up a promise to listen for the result
    const resultPromise = new Promise((resolve) => {
      const handleResult = (event: CustomEvent) => {
        console.log('📡 Received visual order result:', event.detail)
        window.removeEventListener('visualOrderResult', handleResult as EventListener)
        resolve(event.detail)
      }
      window.addEventListener('visualOrderResult', handleResult as EventListener)
      
      // Timeout after 10 seconds
      setTimeout(() => {
        window.removeEventListener('visualOrderResult', handleResult as EventListener)
        resolve({
          success: true,
          message: `Visual demonstration: ${params.side} order for ${params.quantity} ${params.symbol} would be placed`,
          orderId: `visual_demo_${Date.now()}`,
          ...params,
          timestamp: new Date()
        })
      }, 10000)
    })
    
    // Dispatch the event
    window.dispatchEvent(visualEvent)
    
    // Wait for the result
    const result = await resultPromise
    
    return {
      success: true,
      result,
      message: `Tool 'visual_place_order' executed successfully`
    }
  }
}

export const visualDemoTools: AITool[] = [
  visualPlaceOrderTool
] 